import { useCallback } from 'react';

type SetStateFunction<T> = React.Dispatch<React.SetStateAction<T>>;

export const useToggleState = <T extends boolean>(setFunction: SetStateFunction<T>) => {
  return useCallback(() => {
    setFunction((prevState) => !prevState as T);
  }, [setFunction]);
};
